import { render, staticRenderFns } from "./the-stanislavski-technique.vue?vue&type=template&id=29bbe4ec&"
import script from "./the-stanislavski-technique.vue?vue&type=script&lang=js&"
export * from "./the-stanislavski-technique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports